<button [class]="buttonClasses$()" (click)="onClick($event)" (auxclick)="onClick($event, true)">
  @if (prependIcon$() && level$() < 2) {
    <lab-icon class="lab-button-part-icon" [name]="prependIcon$()" />
  } @else if (level$() < 2) {
    <span class="navbar-menu-button-spacer"></span>
  }
  <span class="lab-navbar-menu-button-text">{{ text$() | translate }}</span>

  @if (isNew$()) {
    <lab-badge placement="inline" [visible]="true" mood="success" [ariaLabel]="newBadgeLabel" />
  } @else if (showBadge$()) {
    <lab-badge placement="inline" [visible]="true" mood="info" [ariaLabel]="modifiedBadgeLabel" />
  }

  @if (isMenuGroup$()) {
    <lab-icon class="lab-button-part-icon" [name]="appendIcon$()" />
  }
</button>

@if (isMenuGroup$()) {
  <div class="lab-navbar-menu-group-items-wrapper" [class.lab-navbar-menu-group-items-wrapper-expanded]="expanded$()">
    <div class="lab-navbar-menu-group-items">
      <ng-container [ngTemplateOutlet]="children" />
    </div>
  </div>
}

<ng-template #children>
  @for (child of children$(); track child.id) {
    <lab-navbar-item
      [item]="child"
      [activeRouteIds]="activeRouteIds$()"
      [level]="level$() + 1"
      [expandedIds]="expandedIds$()"
      (expandedChange)="onExpanded($event)"
    />
  }
</ng-template>
